import Vue from 'vue';
import {adminRoles} from '@/enums/userRolesEnum';
import HttpMixin from '@/mixins/HttpMixin';
import TaskDropdown from '@/componentsReusable/tasks/TaskDropdown.vue';
import CreateTaskModal from '@/componentsReusable/tasks/create/CreateTaskModal';
import TaskColumn from '@/componentsReusable/tasks/column/TaskColumn';
import {Task} from '@/interfaces/TaskInterfaces';
import {ViewStateType} from "@/enums/ViewStateType";
import {Column} from '@/interfaces/TaskInterfaces';
import RightPanelTaskColumn from "@/componentsReusable/tasks/column/RightPanelTaskColumn";

export default Vue.component('right-panel-task-column', {
  name: 'RightPanelTasks',
  components: {
    RightPanelTaskColumn,
    TaskDropdown,
    CreateTaskModal,
    TaskColumn,
  },
  mixins: [HttpMixin],
  data() {
    return {
      expanded:false,
      isAuthorized: false,
      showConfirmationModal: false,
      modalTaskId: 0,
      ViewStateType: ViewStateType,
      Column: Column,
    };
  },
  computed: {
    tasks(): Task[] {
      return this.$store.getters["task/getTasksForUserId"](Number(this.userId)).tasks;
    },
    userId(): number {
      return this.$store.state.user.appUserId;
    },
    myTaskCount (): number {
      const appUserId = this.userId;
      return this.$store.getters["task/getTasksForUserId"](appUserId).incomingTasks.filter((task: Task) => task.assignedToAppUserId === appUserId).length;
    },
    emergencyTaskPresent (): boolean {
      const appUserId = this.userId;
      // this checks for emergency tasks for incoming or today(obvious), but also checks the master list for any
      // tasks that are emergency and unread for the unread tab.  This is so that the only time emergency will show
      // on the hover tab that there is a corresponding emergency task in the right nav.

      const tasks = this.$store.getters["task/getTasksForUserId"](appUserId);
      return tasks.incomingTasks.some((task: Task) => task.isEmergency)
         || tasks.todaysTasks.some((task: Task) => task.isEmergency)
         || tasks.tasks.some((task: Task) => !task.isRead && task.isEmergency);
    },
    unreadTaskCount (): number {
      const appUserId = this.userId;
      return this.$store.getters["task/getTasksForUserId"](appUserId).tasks.filter((task: Task) => !task.isRead).length;
    },
  },
  beforeMount: function () {
    this.isAuthorized = this.$store.getters['user/hasRole'](adminRoles);
  },
  methods: {
    expand() {
      this.expanded = true;
      this.$emit('rightTaskExpanded', true)
    },
    hide() {
      this.expanded = false;
      this.$emit('rightTaskExpanded', false)
    },
    createTask() {
      if (!this.showConfirmationModal) {
        this.showConfirmationModal = true;
      }
    },
    taskCreated(newTaskId: number) {
      this.modalTaskId = newTaskId;
      this.showConfirmationModal = false;
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/tasks/rightPanel/RightPanelTasks.ts